import { ReactNode, useMemo } from "react";
import { Sidebar } from "./Sidebar";
import { BottomNav } from "./BottomNav";
import { ScrollToTop } from "./ScrollToTop";
import { DemoBadge } from "@/features/demo/components/DemoBadge";
import { DemoGuidedTour } from "@/features/demo/components/DemoGuidedTour";
import { DemoRestrictionModal } from "@/features/demo/components/DemoRestrictionModal";
import { useDemo } from "@/features/demo/hooks/useDemo";
import { NAV_ITEMS, filterNavItems } from "./navigation/navItems";
import { InstallPrompt } from "./pwa/InstallPrompt";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isDemoMode, isRestrictionModalOpen, closeRestrictionModal } = useDemo();
  const navItems = useMemo(
    () => filterNavItems(NAV_ITEMS, isDemoMode),
    [isDemoMode]
  );

  return (
    <div className="min-h-screen bg-background transition-colors duration-300">
      <ScrollToTop />
      <Sidebar />
      <BottomNav items={navItems} maxVisible={4} />
      <DemoBadge />
      <DemoGuidedTour />
      <DemoRestrictionModal
        isOpen={isRestrictionModalOpen}
        onClose={closeRestrictionModal}
      />
      <InstallPrompt />
      <main className="md:ml-20 pt-4 px-4 md:pt-8 md:px-8 pb-28 md:pb-8">{children}</main>
    </div>
  );
}
